import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepOneCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepOneCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.findWordsStepOneCollections.data.findWordsStepOneCollections,
  (collections = []) => collections
);
const getPageCount = createSelector(
  (state) => state.findWordsStepOneCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getHasLoaded,
  getPageCount,
};
